import { Fragment, useEffect, useRef, useState } from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const VersionHistoryAttachments = (props: any) => {
  const slider = useRef<HTMLDivElement | null>(null);
  let container = slider.current;
  const { eachAttachments } = props;
  const [scrollAmount, setScrollAmount] = useState(0);
  const [totalScrollWidth, setTotalScrollWidth] = useState(0);
  const [totalWindowWidth, setTotalWindowWidth] = useState(
    window.innerWidth * 0.9
  );
  const imageSrc: string = "assets/images/doc.png";
  const getPreviewImage = (image: string) => {
    return image?.includes(".jpg") ||
      image?.includes(".jpeg") ||
      image?.includes(".png") ||
      image?.includes(".avif") ||
      image?.includes(".webp")
      ? image
      : imageSrc;
  };

  const getName = (file: any) => {
    const extensionOfFile = file.originalName.slice(-4);
    const originalFileName = file.originalName?.split("-")[1];

    const splitedName = originalFileName.slice(0, originalFileName.length - 4);
    const requiredName = splitedName + extensionOfFile;
    const ans =
      requiredName?.length > 18
        ? requiredName.slice(0, 8) + "....." + extensionOfFile
        : requiredName;
    return ans;
  };
  const handleScroll = () => {
    if (container) {
      const currentScrollAmount = container.scrollLeft;
      setScrollAmount(currentScrollAmount);
    }
  };
  const handleContainerWidthChange = () => {
    if (container)
      setTotalScrollWidth(
        eachAttachments?.length * 120 + eachAttachments?.length * 12
      );
  };
  useEffect(() => {
    container = slider.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      handleContainerWidthChange();
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
        container.addEventListener("resize", () => {
          setTotalWindowWidth(window.innerWidth * 0.9);
        });
      }
    };
  }, [container]);

  const handleNext = () => {
    if (container) {
      container.scrollLeft += totalWindowWidth;
    }
  };
  const handlePrev = () => {
    if (container) {
      container.scrollLeft -= totalWindowWidth;
    }
  };

  const isNextButtonVisible = slider.current
    ? scrollAmount + slider.current.clientWidth < totalScrollWidth
    : false;

  const isPrevButtonVisible = scrollAmount > 0;
  return (
    <div
      style={{ width: "100%", padding: "10px", maxWidth: "47vw" }}
      className="w-full flex flex-col"
    >
      <div className="pw-text-neutral-600">Attachments : </div>
      <div
        ref={slider}
        className="flex  relative overflow-x-auto gap-x-3 py-3 main-files-container"
      >
        {eachAttachments.map((each: any, index: any) => {
          return (
            <div className="pw-attachments-each-image flex flex-col">
              <div className="pw-attachments-images">
                <img src={getPreviewImage(each.filePath)} alt="" />
              </div>
              <div
                style={{ color: "black" }}
                className="pw-attachments-files-name"
              >
                <div>{getName(each)}</div>
              </div>
            </div>
          );
        })}
        <Fragment>
          {isNextButtonVisible && (
            <div
              onClick={() => handleNext()}
              className="pw-next-btn flex justify-end pr-10 pw-top-45-percent"
            >
              <ArrowForwardIcon />
            </div>
          )}
          {isPrevButtonVisible && (
            <div
              onClick={() => handlePrev()}
              className="pw-next-btn pw-btn-back pw-top-45-percent  flex justify-start pl-10"
            >
              <ArrowBackIcon />
            </div>
          )}
        </Fragment>
      </div>
    </div>
  );
};
export default VersionHistoryAttachments;
